import { FindAdminInformationResult } from "~/api/data/Admin/Information/FindAdminInformationResult";
export class AdminInformationListViewModel {
    constructor(model) {
        this.model = model;
    }
    model = new FindAdminInformationResult();
    get informationNo() {
        return this.model.informationNo;
    }
    get weight() {
        return this.model.weight;
    }
    get startAt() {
        return this.model.startAt;
    }
    get endAt() {
        return this.model.endAt;
    }
    get target() {
        return this.model.target;
    }
    get targetName() {
        return this.model.targetName;
    }
    get isResponseRequired() {
        return this.model.isResponseRequired;
    }
    get isAnswered() {
        return this.model.isAnswered;
    }
    get subject() {
        return this.model.subject;
    }
    get isPastEndAt() {
        return this.model.isPastEndAt;
    }
}
